import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

export const initializeUserStats = async (userId) => {
  try {
    // Initialize user streak total
    await addDoc(collection(db, "userstreaktotal"), {
      userid: userId,
      totalstreakcount: 0,
      date: serverTimestamp(),
    });

    // Initialize user total tokens
    await addDoc(collection(db, "usertotaltokens"), {
      userid: userId,
      totaltokens: 0,
      date: serverTimestamp(),
    });

    console.log(`✅ User stats initialized for userId: ${userId}`);
  } catch (error) {
    console.error("❌ Error initializing user stats:", error);
    throw error;
  }
};
